import { render } from "./InlineColorInput.vue?vue&type=template&id=6a6d6b60&scoped=true"
import script from "./InlineColorInput.vue?vue&type=script&lang=js"
export * from "./InlineColorInput.vue?vue&type=script&lang=js"

import "./InlineColorInput.vue?vue&type=style&index=0&id=6a6d6b60&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6d6b60"]])

export default __exports__